import React, { useState } from 'react';
import { teams, users } from '../mock/teamsData';
import TeamCard from '../components/TeamCard';
import TeamModal from '../components/TeamModal';

const TeamsPage = () => {
  const [teamsList, setTeamsList] = useState(teams);
  const [showModal, setShowModal] = useState(false);
  const [editingTeam, setEditingTeam] = useState(null);

  const handleSaveTeam = (teamData, isEdit) => {
    if (isEdit) {
      setTeamsList(prev => prev.map(t => 
        t.id === editingTeam.id ? { ...teamData, id: editingTeam.id } : t
      ));
    } else {
      setTeamsList(prev => [...prev, {
        ...teamData,
        id: `team-${Date.now()}`
      }]);
    }
    setShowModal(false);
    setEditingTeam(null);
  };

  return (
    <div className="ml-48 p-4">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Equipos de Trabajo</h2>
        <button
          onClick={() => {
            setEditingTeam(null);
            setShowModal(true);
          }}
          className="flex items-center px-4 py-2 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          Nuevo Equipo
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {teamsList.map(team => (
          <TeamCard
            key={team.id}
            team={team}
            users={users}
            onEdit={setEditingTeam}
          />
        ))}
      </div>

      {showModal && (
        <TeamModal
          users={users}
          onClose={() => {
            setShowModal(false);
            setEditingTeam(null);
          }}
          onSave={handleSaveTeam}
          teamToEdit={editingTeam}
        />
      )}
    </div>
  );
};

export default TeamsPage;